"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowStatusesApi = void 0;
const tslib_1 = require("tslib");
const runtime = require("../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class WorkflowStatusesApi extends runtime.BaseAPI {
    /**
     * Returns a status. The status must be associated with an active workflow to be returned.  If a name is used on more than one status, only the status found first is returned. Therefore, identifying the status by its ID may be preferable.  This operation can be accessed anonymously.  [Permissions](#permissions) required: None.
     * Get status
     */
    getStatusRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idOrName'] == null) {
                throw new runtime.RequiredError('idOrName', 'Required parameter "idOrName" was null or undefined when calling getStatus().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:jira-work"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/status/{idOrName}`.replace(`{${"idOrName"}}`, encodeURIComponent(String(requestParameters['idOrName']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.StatusDetailsFromJSON)(jsonValue));
        });
    }
    /**
     * Returns a status. The status must be associated with an active workflow to be returned.  If a name is used on more than one status, only the status found first is returned. Therefore, identifying the status by its ID may be preferable.  This operation can be accessed anonymously.  [Permissions](#permissions) required: None.
     * Get status
     */
    getStatus(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStatusRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns a list of all statuses associated with active workflows.  This operation can be accessed anonymously.  **[Permissions](#permissions) required:** None.
     * Get all statuses
     */
    getStatusesRaw(initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:jira-work"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/status`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.StatusDetailsFromJSON));
        });
    }
    /**
     * Returns a list of all statuses associated with active workflows.  This operation can be accessed anonymously.  **[Permissions](#permissions) required:** None.
     * Get all statuses
     */
    getStatuses(initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStatusesRaw(initOverrides);
            return yield response.value();
        });
    }
}
exports.WorkflowStatusesApi = WorkflowStatusesApi;
//# sourceMappingURL=WorkflowStatusesApi.js.map